import { ShiftCloseoutPaymentTotalInput } from '@/features/graphql/generated/graphql'
import { Layout } from '@/features/layout/types'
import CreateShiftCloseoutConfirmationModal from '@/features/shiftCloseouts/components/CreateShiftCloseoutConfirmationModal'
import ShiftCloseoutForm from '@/features/shiftCloseouts/components/ShiftCloseoutForm'
import { FormOutput } from '@/features/shiftCloseouts/form/types'
import { useCreateShiftCloseout } from '@/features/shiftCloseouts/hooks/useCreateShiftCloseout'
import { DailyShiftCloseout } from '@/features/shiftCloseouts/types'
import { transformReportedPaymentTotals } from '@/features/shiftCloseouts/utils/transformReportedPaymentTotals'
import { useRouter } from 'expo-router'
import { FC, useState } from 'react'

interface ShiftCloseoutContentProps {
    shiftCloseout: DailyShiftCloseout
    layout: Layout
    profileName: string
}

const ShiftCloseoutContent: FC<ShiftCloseoutContentProps> = ({
    shiftCloseout,
    layout,
    profileName,
}) => {
    const router = useRouter()
    const [createShiftCloseout, loading] = useCreateShiftCloseout()
    const [reportedPaymentTotals, setReportedPaymentTotals] =
        useState<ShiftCloseoutPaymentTotalInput[]>()

    const handleSubmit = (formOutput: FormOutput) => {
        setReportedPaymentTotals(
            transformReportedPaymentTotals(shiftCloseout.paymentMethods, formOutput)
        )
    }

    const handleConfirm = async () => {
        if (!reportedPaymentTotals) return

        const created = await createShiftCloseout(reportedPaymentTotals)

        if (!created) return

        router.replace('/shift-closeouts')
    }

    return (
        <>
            <ShiftCloseoutForm
                layout={layout}
                onBack={() => router.dismissTo('/shift-closeouts')}
                onSubmit={handleSubmit}
                profileName={profileName}
                shiftCloseout={shiftCloseout}
            />

            {reportedPaymentTotals && (
                <CreateShiftCloseoutConfirmationModal
                    loading={loading}
                    onCancel={() => setReportedPaymentTotals(undefined)}
                    onConfirm={handleConfirm}
                />
            )}
        </>
    )
}

export default ShiftCloseoutContent
